<script>
import { mapGetters } from 'vuex';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ModalNumBillComponent from '@/components/debts/ModaNumBillComponent.vue';

export default {
	name: "debts-table",
	components: {
		DatePicker,
		ModalNumBillComponent,
	},
	data() {
		return {
			editPay: false,
			load: false,
			catalogue: new Catalogue(),
			tenants: [],
			send: false,
			search: {
				date: '',
				building_id: 3,
				user_id: '',
				company_id: '',
			},
		}
	},
	methods: {
		serviceExisted(id) {
			let sevicesShow = [5,7,8];
			return sevicesShow.includes(id);
		},
		setNumberBill(tenant, service, pay, edit) {
			this.editPay = edit;
			Event.$emit('event-show-addBillServiceTenants', tenant, service, pay);
		},
		async generateBillExternal(id) {
			this.$swal({
				title: 'Crear factura',
				text: '¿ Seguro que quiere crear la factura ?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Facturar',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.numbers = [];
					let _endpoint = '/external_bill';
					let data_form = new FormData();
					data_form.append('id', id);
					this.load = true;
					try {
						let { data } = await request.postMedia(_endpoint, data_form)
						if (data) {
							this.successNotification(data.message);
							this.list();
						}
					} catch (error) {
						this.load = false;
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
						}
					}
				}
			});
		},
		downloadExcel() {
			let data = new URLSearchParams(this.search).toString();
			let url = this.globalUrlFiles + '/tenant_all_two_excel?' + data;
			window.open(url, '_blank');
		},
		getColor(tr) {
			let Nclass = '';
			if (tr.pending == true) {
				Nclass = 'bg-tr';
			}
			if (tr.without_paying == true) {
				Nclass = 'bg-tr-two';
			}

			return Nclass;
		},
		async list() {
			this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/tenant_and_service';
			try {
				let { data } = await service.get(_endpoint, search)
				if (data) {
					console.log(data);
					this.tenants = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	},
	mounted() {
		let DateBill = this.moment().format('YYYY-MM');
		this.search.date = DateBill;
		this.list();
		this.catalogue.get_services();
		this.catalogue.get_buildings();
		this.catalogue.get_companies_all();
		this.catalogue.get_users_profile(7);
	},
	created() {
		Event.$on("event-load-month", async () => {
			this.list();
		});
	},
	watch: {
		'search': {
			handler: function () {
				this.list();
			},
			deep: true
		},
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}

</script>
<template>
	<div class="card card-outline card-info">
		<ModalNumBillComponent :prop_edit="editPay" />
		<div class="card-header">
			<h3 class="card-title">Lista de adeudos</h3>
			<div class="card-tools">
				<!-- <button @click="downloadExcel()" class="btn btn-sm btn-outline-success mr-1">
					<i class="fa-solid fa-file-excel"></i> Excel
				</button> -->
				<!-- <button @click="editBuy()" v-can="'add_contracts'" class="btn btn-sm btn-outline-info">
                        <i class="fa fa-plus"></i> Contrato
                    </button> -->
				<button @click="downloadExcel()" class="btn btn-sm btn-outline-success">
					<i class="fa fa-file-excel"></i> Excel
				</button>
			</div>
		</div>
		<div class="card-body">
			<div class="row">
				<div class="col-md-6">
					<label>Fecha :</label>
					<date-picker format="YYYY-MM" valueType="format" type="month" :clearable="false"
						v-model="search.date"></date-picker>
				</div>
				<div class="col-md-6">
					<label>Propiedad :</label>
					<select class="form-control" v-model="search.building_id" @change="list()">
						<option value="">Todas</option>
						<option :value="building.id" v-for="(building, index) in catalogue.buildings" :key="index">
							{{ building.name }}</option>
					</select>
				</div>
				<div class="col-md-6">
					<label>Usuario :</label>
					<select class="form-control" v-model="search.user_id" @change="list()">
						<option value="">Todas</option>
						<option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
							:key="user_index">{{ user.name }} {{ user.last_name }}</option>
					</select>
				</div>
				<div class="col-md-6">
					<label>Empresa :</label>
					<select class="form-control" v-model="search.company_id" @change="list()">
						<option value="">Todas</option>
						<option :value="company.id" v-for="(company, index) in catalogue.companies_all" :key="index">{{
							company.name }}</option>
					</select>
				</div>
			</div>
			<br>
			<div class="table-responsive">
				<div class="col-12 table-responsive">
					<table class="table table-bordered text-center text-sm" border="1">
						<thead>
							<tr>
								<th>LOCALES</th>
								<th>ARRENDATARIO</th>
								<th>RENTA</th>
								<th v-for="(service, index_service) in catalogue.services"
									:key="`${index_service}-header`" v-show="serviceExisted(service.id)">
									{{ service.name }}
								</th>
								<th>IVA</th>
								<th>IEPS</th>
								<th>ISR RET</th>
								<th>IVA RET</th>
								<th>DESCUENTO</th>
								<th>TOTAL</th>
								<th>FECHAS</th>								
								<th>CONCEPTO 1</th>
								<th>CONCEPTO 2</th>
								<th>CONCEPTO 3</th>
								<th>CONCEPTO 4</th>
								<th>CONCEPTO 5</th>
								<th>OPCIONES</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="26">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="tenants.length > 0">
							<tr v-for="service in tenants" :key="service.id">							
								<td>
									{{ service.tenant.department ? service.tenant.department.number + '-' +
										service.tenant.department.level :
										'S/N' }}
								</td>
								<td>
									{{ service.tenant.user ? service.tenant.user.name + ' ' +
										service.tenant.user.last_name : 'S/N' }}
								</td>

								<td>
									<span v-if="service.service_id == 0">
										{{ service.subtotal | toCurrency }}
									</span>
									<span v-else>$ 0.00</span>

								</td>

								<td v-for="(serv, index_serv) in catalogue.services"
									:key="`${index_serv}-body`" v-show="serviceExisted(serv.id)">									
									<span v-if="service.service_id === serv.id">{{ service.subtotal | toCurrency }}</span>
									<span v-else>$0.00</span>
								</td>

								<td>
									{{ service.iva | toCurrency }}

								</td>

								<td>
									{{ service.ieps | toCurrency }}
								</td>

								<td>
									{{ service.isr_ret | toCurrency }}
								</td>

								<td>
									{{ service.iva_ret | toCurrency }}
								</td>

								<td>
									{{ service.discount | toCurrency }}
								</td>

								<td>
									{{ service.amount | toCurrency }}
								</td>
								<td>
									{{ service.tenant.star_date | toDateTime }}
									<br>-<br> 
								
									{{ service.tenant.dateEnd | toDateTime }}
								</td>
								<td v-for="(concept, index_concept) in service.names" :key="`${index_concept}-concept`">
									{{ concept }}
								</td>
								<td v-for="i in 5 - service.names.length" :key="i">

								</td>
								<td>
									<div v-if="service.pay_bill">
										<button @click="setNumberBill(service.tenant, service, service.pay_bill, false)"
											class="btn btn-outline-primary btn-sm m-1">
											<i class="fa fa-eye"></i> Ver número de factura
										</button>

										<!-- Factura -->
										<button v-if="!service.pay_bill.external_bill"
											class="btn btn-sm m-1 btn-outline-primary"
											@click="generateBillExternal(service.pay_bill.id)">
											<i class="fa-solid fa-file-invoice"></i>
											Facturar
										</button>

										<div v-if="service.pay_bill.external_bill">
											<a :href="`${globalUrlFiles}/file/bill_external/${service.pay_bill.external_bill.id}/pdf`"
												v-if="service.pay_bill.external_bill" target="_blank"
												class="btn btn-outline-info btn-sm m-1">
												<i class="fa-regular fa-file-pdf"></i> Factura PDF
											</a>
											<a :href="`${globalUrlFiles}/file/bill_external/${service.pay_bill.external_bill.id}/xml`"
												v-if="service.pay_bill.external_bill" target="_blank"
												class="btn btn-outline-info btn-sm m-1">
												<i class="fa-regular fa-file"></i> Factura XML
											</a>
										</div>

									</div>
									<div v-else>
										<button @click="setNumberBill(service.tenant, service, service.pay_bill, true)"
											class="btn btn-outline-success btn-sm m-1">
											<i class="fa fa-plus"></i> Crear número de factura
										</button>

									</div>

								</td>

							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="26">
									<h5>Sin resultados</h5>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<style type="text/css">
.bg-tr {
	background-color: #d6d6d6;
}

.bg-tr-two {
	background-color: #ffc5c5;
}
</style>